// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__1fJsU","activeHandle":"RangeSlider_activeHandle__3apC2"};